import { useRouteError, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

const RootErrorBoundary = () => {
  let error = useRouteError()
  const navigate = useNavigate()

  const isChunkLoadError =
    error?.message?.includes('Failed to fetch dynamically imported module') ||
    error?.message?.includes('Importing a module script failed') ||
    error?.message?.includes('ChunkLoadError') ||
    error?.message?.includes('Unable to preload CSS') ||
    error?.message?.includes('error loading dynamically imported module') ||
    error?.name === 'ChunkLoadError'

  useEffect(() => {
    if (isChunkLoadError) {
      console.warn(
        'Chunk loading error detected - likely a new deployment. Auto-reloading in 3 seconds...'
      )
      setTimeout(() => {
        window.location.reload()
      }, 3000)
    }
  }, [isChunkLoadError])

  const handleReload = () => {
    window.location.reload()
  }

  const handleGoHome = () => {
    navigate('/')
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '20px',
        fontFamily: 'system-ui, -apple-system, sans-serif',
      }}
    >
      <div style={{ maxWidth: '500px', textAlign: 'center' }}>
        <h1 style={{ fontSize: '48px', marginBottom: '16px', color: '#d32f2f' }}>Oops!</h1>
        <h2 style={{ fontSize: '24px', marginBottom: '24px', color: '#333' }}>
          Something went wrong
        </h2>
        <p style={{ fontSize: '16px', marginBottom: '32px', color: '#666' }}>
          {isChunkLoadError
            ? 'A new version is available. Reloading...'
            : 'An unexpected error occurred. Please try reloading the page.'}
        </p>

        {process.env.NODE_ENV === 'development' && error && (
          <pre
            style={{
              textAlign: 'left',
              backgroundColor: '#f5f5f5',
              padding: '16px',
              borderRadius: '4px',
              marginBottom: '24px',
              overflow: 'auto',
              maxHeight: '200px',
              fontSize: '12px',
            }}
          >
            {error.message || JSON.stringify(error, null, 2)}
          </pre>
        )}

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <button
            onClick={handleReload}
            style={{
              padding: '12px 24px',
              fontSize: '16px',
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: '500',
            }}
          >
            Reload page
          </button>
          {!isChunkLoadError && (
            <button
              onClick={handleGoHome}
              style={{
                padding: '12px 24px',
                fontSize: '16px',
                backgroundColor: '#fff',
                color: '#1976d2',
                border: '1px solid #1976d2',
                borderRadius: '4px',
                cursor: 'pointer',
                fontWeight: '500',
              }}
            >
              Go to home
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default RootErrorBoundary
